// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up-tray.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-up-tray'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowUpTrayIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
